<template>
    <div v-if="alert.visible" :class="['alert app-alert mt-1 alert-' + alert.type]" role="alert" aria-live="polite">
        <strong class="a-msg">
            {{ alert.message }}
            <router-link v-if="alert.linkText && alert.linkRoute" :to="alert.linkRoute"><strong>{{ alert.linkText }}</strong></router-link>
        </strong>
        <button type="button" class="close-a" aria-label="Dismiss alert" v-on:click="closeAlert">
            <font-awesome-icon icon="xmark" aria-hidden="true" />
        </button>
    </div>
</template>

<script src="./AlertScript.vue"/>
